/**
 * Step 4 — Project Creation
 *
 * Focuses solely on the Project Creation tab from Project Settings.
 * No tab bar shown — the wizard provides the context.
 */

import { StepWrapper } from '../StepWrapper';
import SettingsProject from '@/pages/settings-project';

interface StepProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
  isLastStep: boolean;
}

export function Step3ProjectConfig({ onNext, onBack, onSkip, isLastStep }: StepProps) {
  return (
    <StepWrapper
      barState="default"
      barMessage="Define how projects are created — numbering, required fields and default settings."
      showBack={true}
      showSkip={true}
      nextLabel={isLastStep ? 'Finish Setup →' : 'Next Step →'}
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
    >
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-foreground">Project Creation</h2>
        <p className="text-sm text-muted-foreground mt-0.5">
          Set up how new projects are created, numbered and what information is required at creation time.
        </p>
      </div>
      <div className="rounded-lg border border-border overflow-hidden bg-background shadow-sm">
        <SettingsProject defaultTab="project-creation" />
      </div>
    </StepWrapper>
  );
}
